import { resourceEnum } from "components/expenses/constants";
import { FilesField } from "components/shared/form";
import { requiredField } from "helpers/validators";
import React, { Fragment } from "react";
import { filteredNamesList as getDrivers } from "sources/books/drivers";
import { uploadFile } from "sources/books/expenses";
import { filteredNumbersList as getTrailers } from "sources/books/trailers";
import { filteredNumbersList as getTrucks } from "sources/books/trucks";

export default function Expense(props) {
    const {
        config,
        renderField,
        renderSelect,
        renderDateField,
        onChange,
        item,
        i,
        remove,
        modal,
        itemIds,
        driver,
        secondaryDriver,
        carOption,
        trailerOption,
    } = props;

    const removeExpenses = () => {
        return modal({
            name: "confirm",
            title: "Удаление расходов",
            text: "Вы уверены, что хотите удалить расходы?",
            action: () => remove(i),
        });
    };

    const renderResource = () => {
        if (!item.resource) {
            return null;
        }

        const selectByResource = () => {
            switch (item.resource) {
                case resourceEnum.CAR: {
                    const ids = [...itemIds.carIds];
                    if (carOption?.carId) {
                        ids.push(carOption.carId);
                    }
                    return (
                        <Fragment key={ids.join("_")}>
                            {renderSelect({
                                ...config.carId,
                                url: (params) => getTrucks(params, ids),
                                validators: [requiredField],
                                required: true,
                                fieldWrapper: "col-sm-8 col-md-5",
                                disabled: !!item.id,
                            })}
                        </Fragment>
                    );
                }
                case resourceEnum.TRAILER: {
                    const ids = [...itemIds.trailerIds];
                    if (trailerOption?.trailerId) {
                        ids.push(trailerOption.trailerId);
                    }
                    return (
                        <Fragment key={ids.join("_")}>
                            {renderSelect({
                                ...config.trailerId,
                                url: (params) => getTrailers(params, ids),
                                validators: [requiredField],
                                required: true,
                                fieldWrapper: "col-sm-8 col-md-5",
                                disabled: !!item.id,
                            })}
                        </Fragment>
                    );
                }
                case resourceEnum.DRIVER: {
                    const ids = [...itemIds.driverIds];
                    if (driver?.id) {
                        ids.push(driver.id);
                    }
                    if (secondaryDriver?.id) {
                        ids.push(secondaryDriver.id);
                    }
                    return (
                        <Fragment key={ids.join("_")}>
                            {renderSelect({
                                ...config.driverId,
                                url: (params) => getDrivers(params, ids),
                                validators: [requiredField],
                                required: true,
                                fieldWrapper: "col-sm-8 col-md-5",
                                disabled: !!item.id,
                            })}
                        </Fragment>
                    );
                }
            }
        };
        return selectByResource();
    };

    const onChangeResource = ({ name, value }, i) => {
        onChange({ name, value }, i);
        setTimeout(() => {
            switch (value) {
                case resourceEnum.CAR:
                    onChange({ name: "trailerId", value: null }, i);
                    setTimeout(() => onChange({ name: "driverId", value: null }, i), 0);
                    break;
                case resourceEnum.TRAILER:
                    onChange({ name: "carId", value: null }, i);
                    setTimeout(() => onChange({ name: "driverId", value: null }, i), 0);
                    break;
                case resourceEnum.DRIVER:
                    onChange({ name: "carId", value: null }, i);
                    setTimeout(() => onChange({ name: "trailerId", value: null }, i), 0);
                    break;
            }
        }, 0);
    };

    const renderFiles = () => (
        <FilesField
            isMultiple
            withoutDownload
            uploadFile={uploadFile}
            modal={modal}
            files={item.files}
            onChange={(files) => {
                onChange({ name: "files", value: files }, i);
                setTimeout(() => {
                    onChange({ name: "fileIds", value: files.map((file) => file.id) }, i);
                }, 0);
            }}
        />
    );

    return (
        <div className="mb-3">
            <div className="book-form__section-head book-form__section-head--closable">
                <div className="book-form__section-close close" onClick={removeExpenses} title="Удалить расход" />
                <div className="pl-3">
                    <strong>#{i + 1} Расход</strong>
                </div>
            </div>
            {renderSelect({
                ...config.resource,
                fieldWrapper: "col-sm-8 col-md-5",
                onChange: ({ name, value }) => onChangeResource({ name, value }, i),
                disabled: !!item.id,
            })}
            {renderResource()}
            {renderSelect({ ...config.typeId, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderDateField({ ...config.date, wrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...config.value, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderField({ ...config.comment, fieldWrapper: "col-sm-8 col-md-5" })}
            {renderFiles()}
        </div>
    );
}
